import React from "react";
import {
  Modal, Descriptions, Tag, Table, Divider,
} from "antd";

const STATUS_CONFIG = {
  active:   { color: "green",   text: "Активна"      },
  reversed: { color: "orange",  text: "Распроведена" },
  canceled: { color: "default", text: "Отменена"     },
  deleted:  { color: "red",     text: "Удалена"      },
};

export default function TechOperationDetailModal({ record, onClose }) {
  if (!record) return null;

  const status = STATUS_CONFIG[record.status] || { color: "default", text: record.status };

  const componentColumns = [
    { title: "Наименование", dataIndex: "name",       key: "name"       },
    { title: "Номенклатура", dataIndex: "nomeclature_id", key: "nom",
      render: (id) => id ? <Tag>#{id}</Tag> : "—" },
    { title: "Количество",   dataIndex: "quantity",   key: "quantity"   },
    { title: "Вес брутто",   dataIndex: "gross_weight", key: "gross",
      render: (v) => v ?? "—" },
    { title: "Вес нетто",    dataIndex: "net_weight", key: "net",
      render: (v) => v ?? "—" },
  ];

  return (
    <Modal
      open={!!record}
      onCancel={onClose}
      footer={null}
      title={`Тех. операция ${String(record.id).slice(0, 8)}…`}
      width={820}
    >
      <Descriptions column={2} size="small" bordered>
        <Descriptions.Item label="Статус">
          <Tag color={status.color}>{status.text}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Выход">
          {record.output_quantity} ед.
        </Descriptions.Item>
        <Descriptions.Item label="Склад сырья">
          {record.from_warehouse_id ? `#${record.from_warehouse_id}` : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Склад продукта">
          {record.to_warehouse_id ? `#${record.to_warehouse_id}` : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Докум. списания">
          {record.consumption_doc_id
            ? <Tag color="red">Списание #{record.consumption_doc_id}</Tag>
            : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Докум. производства">
          {record.production_doc_id
            ? <Tag color="green">Производство #{record.production_doc_id}</Tag>
            : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Продажа">
          {record.docs_sales_id ? `#${record.docs_sales_id}` : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Создана">
          {record.created_at
            ? new Date(record.created_at).toLocaleString("ru-RU")
            : "—"}
        </Descriptions.Item>
      </Descriptions>

      <Divider>Компоненты (сырьё)</Divider>
      <Table
        rowKey="id"
        size="small"
        pagination={false}
        dataSource={record.component_quantities || []}
        columns={componentColumns}
        locale={{ emptyText: "Нет компонентов" }}
      />
    </Modal>
  );
}